import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { SessionManager } from '../../common/helpers/session-manager';
import { PaymentStatus } from '../../common/models/paymentStatus';
import { PaymentService } from '../services/payment.service';

@Component({
  selector: 'app-payment-auto-renew',
  templateUrl: './payment-auto-renew.component.html',
  styleUrls: ['./payment-auto-renew.component.css']
})
export class PaymentAutoRenewComponent implements OnInit {

  // tslint:disable-next-line:max-line-length
  constructor(private router: Router, private activatedRoute: ActivatedRoute, private sessionManager: SessionManager, private paymentService:PaymentService) { }
  transactionId: string;
  responseCode: string;
  paymentStatus = new PaymentStatus();
  sessionId = localStorage.getItem('sessionID');

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.transactionId = params.transactionId;
      this.responseCode = params.responseCode;
    });
  }

  savePanHash() {
    const customerDetails = this.sessionManager.getCurrentUser();
    const shopingCartItem = this.sessionManager.getShoppingCartData();
    const promoCode = this.sessionManager.getPromoCode();
    this.paymentService.savePanHash(promoCode,
      // tslint:disable-next-line:max-line-length
      customerDetails.id, shopingCartItem.orderId, this.transactionId, this.sessionId, 'D47BE4E1-1C6A-4083-89F1-96E775C564E7', customerDetails.email).subscribe((response: any) => {
        this.paymentStatus.status = '9';
        this.sessionManager.setPaymentStatus(this.paymentStatus);
        // tslint:disable-next-line:max-line-length
        this.router.navigate(['paymentprocessing'], { queryParams: { transactionId: this.transactionId, responseCode: this.responseCode } });
      }, error => {
      });
  }

  gotoProcessing() {
    this.paymentStatus.status = '9';
    this.sessionManager.setPaymentStatus(this.paymentStatus);
    this.router.navigate(['paymentprocessing'], { queryParams: { transactionId: this.transactionId, responseCode: this.responseCode } });
  }
}



// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/payment-gateway/payment-auto-renew/payment-auto-renew.component.ts